import ePaymentType from "../../enums/ePaymentType"

const isServiceFeePaymentMethod = (paymentMethod: ePaymentType): boolean => {
  return [
    ePaymentType.CARD_INPUT,
    ePaymentType.CARD_READER,
    ePaymentType.LINK
  ].includes(paymentMethod)
}

export default isServiceFeePaymentMethod
